import React from 'react';
import { useTranslation } from 'react-i18next';
import { MigrationStatus } from '../../../../api/General/blobMigration';
import Button from '../../../../components/ui/Button';

interface MigrationActionsProps {
  isMigrating: boolean;
  status: MigrationStatus | null;
  onStart: () => void;
  onRetry: () => void;
}

export default function MigrationActions({
  isMigrating,
  status,
  onStart,
  onRetry,
}: MigrationActionsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex gap-3 rounded-lg border border-border bg-card p-4">
      <Button
        iconName={isMigrating ? undefined : 'Play'}
        loading={isMigrating}
        onClick={onStart}
        disabled={isMigrating || !status || status.totalPending === 0}
      >
        {isMigrating ? t('Migrating...') : t('Start Migration')}
      </Button>
      <Button
        variant="outline"
        iconName="RefreshCw"
        onClick={onRetry}
        disabled={isMigrating || !status || status.totalFailed === 0}
      >
        {t('Retry Failed')}
      </Button>
    </div>
  );
}
